import pageText from '../content/PrivacyPolicy.md?raw';
import LegalPageLayout from './LegalPageLayout';

export default function PrivacyPolicyPage() {
  return <LegalPageLayout content={pageText} />;
}
